import ReturnRequests from "layouts/returnRequest/List";
import View from "layouts/returnRequest/View";
import ProtectedRoute from "routes/protectedRoutes.js";

const ReturnRequestRoutes = [
  {
    route: "/returns/list/:pageNo",
    key: "return-request",
    component: <ProtectedRoute check="logout"><ReturnRequests /></ProtectedRoute>
  },
  {
    route: "/returns/view/:returnId",
    key: "return-request-view",
    component: <ProtectedRoute check="logout"><View /></ProtectedRoute>
  }
  ];

export default ReturnRequestRoutes;
